import React from "react";

function ReplacementsCountToday({replacementsPerSchoolToday, cardReplacementsToday, wbReplacementsToday}) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const todayFormatted = new Date().toLocaleDateString('en-US', options);

    return (
        <div className="col-lg-12">
            <div className="card custom-card" style={{paddingBottom:"10px"}}>
            <div className="card-body map-card">
                <div className="item-title">
                <h5 style={{marginBottom:10}}>Replacements / Swaps Today ({todayFormatted})</h5>
                </div>
                <table className="table mb-0 color-span">
                <thead>
                <tr>
                <th className="w-50">School</th>
                <th></th>

                <th className="py-2 px-0" scope="col">Card</th>
                <th className="py-2 px-0"scope="col"> Wristband</th>
                </tr>
                </thead>
                <tbody>
                {replacementsPerSchoolToday === "404" ? (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }} className="py-2 px-0">
        No swaps / replacements today
      </td>
    </tr>
  ) : (
    Object.keys(replacementsPerSchoolToday).map((schoolId, key) => {
      const school = replacementsPerSchoolToday[schoolId];
      return (
        <tr key={key}>
          <td className="py-2 px-0">
            <span className="w-50">{school.school_name}</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
              {/* Safe access to replacements[11] with fallback to 0 */}
              {school.replacements?.[11] || 0}
            </span>
          </td>
          <td className="py-2 px-0">
            <span className="">
              {/* Safe access to replacements[13] with fallback to 0 */}
              {school.replacements?.[13] || 0}
            </span>
          </td>
        </tr>
      );
    })
  )}
  <tr>
                   
                    <td className="py-2 px-0">{" "}
                        <span className="w-50">
                        Total{" "}
                        </span>{" "}
                    </td>
                    <td>:</td>
                    <td className="py-2 px-0">{" "}
                        <span className="">
                        {cardReplacementsToday?cardReplacementsToday.total_c:"..."}
                        </span>{" "}
                    </td>
                    <td className="py-2 px-0">{" "}
                        <span className="">
                        {wbReplacementsToday?wbReplacementsToday.total_c:"..."}
                        </span>{" "}
                    </td>
                    </tr>
                   
                </tbody>
                </table>
            </div>
            </div>
        </div>
        
    );
}

export default ReplacementsCountToday;
